// ABOUTME: Blue filled plus icon component
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const PlusBlueIcon = ({ className = "", size = 10, color = "#457FE5" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.6875 5C9.6875 5.14918 9.62824 5.29226 9.52275 5.39775C9.41726 5.50324 9.27418 5.5625 9.125 5.5625H5.5625V9.125C5.5625 9.27418 5.50324 9.41726 5.39775 9.52275C5.29226 9.62824 5.14918 9.6875 5 9.6875C4.85082 9.6875 4.70774 9.62824 4.60225 9.52275C4.49676 9.41726 4.4375 9.27418 4.4375 9.125V5.5625H0.875C0.725816 5.5625 0.582742 5.50324 0.477252 5.39775C0.371763 5.29226 0.3125 5.14918 0.3125 5C0.3125 4.85082 0.371763 4.70774 0.477252 4.60225C0.582742 4.49676 0.725816 4.4375 0.875 4.4375H4.4375V0.875C4.4375 0.725816 4.49676 0.582742 4.60225 0.477252C4.70774 0.371763 4.85082 0.3125 5 0.3125C5.14918 0.3125 5.29226 0.371763 5.39775 0.477252C5.50324 0.582742 5.5625 0.725816 5.5625 0.875V4.4375H9.125C9.27418 4.4375 9.41726 4.49676 9.52275 4.60225C9.62824 4.70774 9.6875 4.85082 9.6875 5Z"
      fill={color}
    />
  </svg>
)
